import React from 'react';
import autobind from 'autobind-decorator';
import {Col, Row} from 'react-bootstrap';

export class NonMutableList extends React.Component {
    @autobind
    getData() {
        if(this.props.Data) {
            if(this.props.GetSortKey && this.props.GetSortKey()) {
                let key = this.props.GetSortKey();
                return this.props.Data.sort((a, b) => {
                    return a[key] - b[key];
                });
            }

            return this.props.Data;
        }

        return null;
    }

    render() {
        return (
            <div>
                {
                    this.getData() ?
                        this.getData().map((x) =>
                            <Row key={this.props.GetItemKey(x)} className="pop-row">
                                <Col xs={this.props.Editable ? 11 : 12} className="pop-col">
                                    <this.props.Type
                                        Key={this.props.GetItemKey(x)}
                                        Item={x}
                                        UpdateItem={(value) => this.props.UpdateItem(this.props.GetItemKey(x), value)}
                                        {...this.props.AdditionalTypeProps}
                                    />
                                </Col>
                            </Row>
                        ) :
                        null
                }
            </div>
        );
    }
}

